import { ApprovalRequestsTab } from '../common'
import { Request, Students, RequestHistory } from '../exceptiontesting'
import { ContactInformation } from '../common/detail'
import { selectCurrentFilter } from '../../../selectors/filters'
import {
  APPROVAL_REQUEST_CONFIG,
  ARTYPE_EXCEPTIONTESTING,
  AR_ID,
  AR_AICODE,
  AR_STATUS,
} from '../../../constants/ApprovalRequestConstants'

const mapStateToProps = state => ({
  groupByAICode: selectCurrentFilter(state).groupByAICode || false,
})

export const ExceptionTestingTab = connect(mapStateToProps)(({ groupByAICode }) => {
  const requestDetailPanels = [
    { title: 'Students', PanelBody: Students, panelId: 'studentsPanel', openByDefault: true },
    {
      title: 'Contact Information',
      PanelBody: ContactInformation,
      panelId: 'contactInformationPanel',
    },
    { title: 'Request History', PanelBody: RequestHistory, panelId: 'requestHistoryPanel' },
  ]
  const headerColumns = [
    {
      headerText: { title: 'ID' },
      headerAttributes: { id: 'approvalRequestIdCol' },
      key: [`${APPROVAL_REQUEST_CONFIG[ARTYPE_EXCEPTIONTESTING].idField}`, 'examDate'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'AI Code' },
      headerAttributes: { id: 'aiCodeCol' },
      key: ['aiCode'],
      sortDir: ['asc'],
    },
    {
      headerText: { title: 'Course Name' },
      headerAttributes: { id: 'courseCol' },
      key: ['course', 'aiCode'],
      sortDir: ['asc', 'asc'],
      defaultSort: true,
    },
    {
      headerText: { title: 'Quantity' },
      headerAttributes: { id: 'totalExamsCol' },
      key: ['totalExams', 'aiCode'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'Status' },
      headerAttributes: { id: 'statusCol' },
      key: ['statusSortOrder', 'aiCode'],
      sortDir: ['asc', 'asc'],
    },
  ]

  const approvalRequestColumns = [
    { header: AR_ID },
    { header: AR_AICODE },
    { header: 'courseCol', field: 'course' },
    { header: 'totalExamsCol', field: 'totalExams' },
    { header: AR_STATUS },
  ]

  return (
    <ApprovalRequestsTab
      title="Exception Testing"
      arType={ARTYPE_EXCEPTIONTESTING}
      tableSummary={`Exception testing approval requests are listed in ascending order ${
        groupByAICode ? 'grouped by AI code' : 'by course name and AI code'
      }.`}
      headerColumns={headerColumns}
      approvalRequestColumns={approvalRequestColumns}
      RequestComponent={Request}
      requestDetailPanels={requestDetailPanels}
    />
  )
})
